import {
  type ServiceAccountQueries,
  defServiceAccountQueries,
} from '@kizen/query/service-account';
import AxiosService from '__services/AxiosService';

const queries: ServiceAccountQueries = defServiceAccountQueries(AxiosService);

export const serviceAccountQuery: ServiceAccountQueries['serviceAccountQuery'] =
  queries.serviceAccountQuery;

export const primaryTokenQuery: ServiceAccountQueries['primaryTokenQuery'] =
  queries.primaryTokenQuery;

export const secondaryTokenQuery: ServiceAccountQueries['secondaryTokenQuery'] =
  queries.secondaryTokenQuery;

export const serviceAccountsInfiniteQuery: ServiceAccountQueries['serviceAccountsInfiniteQuery'] =
  queries.serviceAccountsInfiniteQuery;

export const serviceAccountHistoryQuery: ServiceAccountQueries['serviceAccountHistoryQuery'] =
  queries.serviceAccountHistoryQuery;
